module.exports = __webpack_public_path__ + "static/media/branches_move.1a6ce25f.png";